import looseEqual from './loose-equal';

var looseIndexOf = function looseIndexOf(arr, val) {
  // Assumes that the first argument is an array
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) {
      return i;
    }
  }

  return -1;
};

export default looseIndexOf;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/utils/loose-index-of.js
// module id = ./node_modules/bootstrap-vue/esm/utils/loose-index-of.js
// module chunks = 0 1